import React, {useState, useEffect} from 'react'
import { Images } from '../../constants';
import { client } from '../../client';
import { AppWrapper, MotionWrap } from '../../wrapper';
import './footer.scss';
import { FaChromecast } from 'react-icons/fa';

const Footer = () => {
    
  const [formData, setFormData] = useState({name: '', email: '', message: ''});
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const { name, email, message } = formData;

  const handleChangeInput = (e) => {
    const { name, value } = e.target;

    setFormData({...formData, [name]: value})
  }

  const handleSubmit = () => {
    setLoading(true);

    const contact = {
      _type: 'contact',
      name: name,
      email: email,
      message: message
    }

    client.create(contact).then(() => {
      setLoading(false);
      setIsFormSubmitted(true);
    })
  }



  return (
   <>
     <h2 id='contact' className='head-text'>
          Take a <span>Coffee</span> & chat with <span>Me</span>.
     </h2>

     <div className='app__footer-cards'>
      <div className='app__footer-card'>
        <img src={Images.email1} alt="email" />
        <a href="mailto:ajith.gowtham18@gmail.com" className='p-text'>ajith.gowtham18@gmail.com</a>

      </div>

      <div className='app__footer-card'>
        <img src={Images.mobile} alt="mobile" />
        <a href="tel: +91-9600502469" className='p-text'>+91-9600502469</a>
      </div>
     </div>

     {!isFormSubmitted ? 

     <div className='app__footer-form app__flex'>
       
       <div className='app__flex'>
        
       <input className='p-text' type="text" placeholder='Your Name' name='name' value={name} onChange={handleChangeInput} />

       </div>

       <div className='app__flex'>
        
       <input className='p-text' type="email" placeholder='Your Email' name='email' value={email} onChange={handleChangeInput} />

       </div>

       <div>
         <textarea className='p-text' placeholder='Your Message' value={message}  name='message' onChange={handleChangeInput} />
       </div>

       <button type='button' className='p-text' onClick={handleSubmit}>{loading ? 'Sending' : 'Send Message'}</button>
     </div>

     : <div>
       <h3 className='head-text'> Thank <span>You</span> For Getting in <span>Touch</span>!</h3>
     </div>}
   </>
  )
}

export default AppWrapper(
  MotionWrap(Footer, 'app__footer'),
    'footer',
    'app__whitebg');